<template>
    <PrismicImage
        v-if="prismicImage"
        :class="imageClass"
        :field="prismicImage"
        :loading="loading"
        :provider="provider"
        :height="height || prismicImage?.dimensions?.height"
        :width="width || prismicImage?.dimensions?.width"
        :imgix-params="{auto: ['enhance', 'format']}"
        :widths="widths"
    />
</template>

<script setup lang="ts">
    import type {ImageFieldImage} from '@prismicio/types';
    import {PrismicImage} from '@prismicio/vue';

    interface Props {
        loading?: 'eager' | 'lazy';
        provider?: string;
        prismicImage?: ImageFieldImage;
        height?: string;
        width?: string;
        widths?: number[];
        imageClass?: string;
    }

    withDefaults(defineProps<Props>(), {
        loading: 'lazy',
    });
</script>
